import React from "react";

const SvgWrapper = ({
  width = 24,
  height = 24,
  viewBox = "0 0 24 24",
  children,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {children}
  </svg>
);

export const ArrowsExchange = (props) => (
  <SvgWrapper width="50" height="50" viewBox="0 0 50 50" {...props}>
    <path
      d="M20.0221 12.5555C19.3621 12.5555 18.729 12.8177 18.2622 13.2845C17.7955 13.7512 17.5333 14.3843 17.5333 15.0444C17.5333 15.7045 17.7955 16.3375 18.2622 16.8043C18.729 17.271 19.3621 17.5333 20.0221 17.5333H33.9251L30.7069 20.7514C30.2536 21.2208 30.0027 21.8495 30.0084 22.5021C30.0141 23.1547 30.2758 23.7789 30.7373 24.2404C31.1987 24.7018 31.823 24.9636 32.4755 24.9692C33.1281 24.9749 33.7568 24.724 34.2262 24.2707L41.6929 16.804C42.1595 16.3373 42.4216 15.7043 42.4216 15.0444C42.4216 14.3844 42.1595 13.7515 41.6929 13.2847L34.2262 5.81806C33.9966 5.58034 33.722 5.39073 33.4184 5.26029C33.1147 5.12985 32.7881 5.06119 32.4576 5.05832C32.1272 5.05545 31.7994 5.11842 31.4936 5.24357C31.1877 5.36871 30.9098 5.55352 30.6761 5.78721C30.4424 6.02089 30.2576 6.29878 30.1325 6.60466C30.0073 6.91053 29.9443 7.23827 29.9472 7.56874C29.9501 7.89922 30.0187 8.22581 30.1492 8.52946C30.2796 8.83312 30.4692 9.10775 30.7069 9.33734L33.9251 12.5555H20.0221Z"
      fill="url(#paint0_linear_arrows)"
    />
    <path
      d="M29.9777 37.4444C30.6378 37.4444 31.2709 37.1821 31.7376 36.7154C32.2044 36.2486 32.4666 35.6156 32.4666 34.9555C32.4666 34.2954 32.2044 33.6623 31.7376 33.1956C31.2709 32.7288 30.6378 32.4666 29.9777 32.4666H16.0748L19.2929 29.2485C19.5306 29.0189 19.7202 28.7442 19.8507 28.4406C19.9811 28.1369 20.0498 27.8103 20.0527 27.4799C20.0555 27.1494 19.9925 26.8216 19.8674 26.5158C19.7423 26.2099 19.5575 25.932 19.3238 25.6983C19.0901 25.4646 18.8122 25.2798 18.5063 25.1547C18.2004 25.0295 17.8727 24.9666 17.5422 24.9694C17.2118 24.9723 16.8852 25.041 16.5815 25.1714C16.2779 25.3018 16.0032 25.4915 15.7736 25.7292L8.30696 33.1958C7.84037 33.6626 7.57825 34.2955 7.57825 34.9555C7.57825 35.6154 7.84037 36.2484 8.30696 36.7151L15.7736 44.1818C16.243 44.6352 16.8717 44.886 17.5243 44.8804C18.1769 44.8747 18.8011 44.6129 19.2626 44.1515C19.7241 43.69 19.9858 43.0658 19.9915 42.4132C19.9972 41.7606 19.7463 41.1319 19.2929 40.6625L16.0748 37.4444H29.9777Z"
      fill="url(#paint1_linear_arrows)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_arrows"
        x1="13.9299"
        y1="64.3767"
        x2="65.725"
        y2="29.0871"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#15BD24" />
        <stop offset="1" stopColor="#1D9BC3" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_arrows"
        x1="13.9299"
        y1="64.3767"
        x2="65.725"
        y2="29.0871"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#15BD24" />
        <stop offset="1" stopColor="#1D9BC3" />
      </linearGradient>
    </defs>
  </SvgWrapper>
);

export const Cash = (props) => (
  <SvgWrapper width="42" height="34" viewBox="0 0 42 34" {...props}>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M27.2222 0.407349C29.9309 0.407349 32.2373 2.1392 33.0918 4.5555H14.7777C12.0273 4.5555 9.3896 5.64809 7.44478 7.59291C5.49995 9.53773 4.40736 12.1755 4.40736 14.9259V24.9436C3.19388 24.5143 2.14335 23.7193 1.40045 22.6681C0.657561 21.6169 0.258845 20.3612 0.259217 19.074V6.62957C0.259217 4.97933 0.91477 3.39669 2.08166 2.2298C3.24856 1.0629 4.8312 0.407349 6.48144 0.407349H27.2222ZM35.5185 8.70364H14.7777C13.1275 8.70364 11.5449 9.3592 10.378 10.5261C9.21107 11.693 8.55551 13.2756 8.55551 14.9259V27.3703C8.55551 29.0205 9.21107 30.6032 10.378 31.7701C11.5449 32.937 13.1275 33.5925 14.7777 33.5925H35.5185C37.1687 33.5925 38.7514 32.937 39.9183 31.7701C41.0851 30.6032 41.7407 29.0205 41.7407 27.3703V14.9259C41.7407 13.2756 41.0851 11.693 39.9183 10.5261C38.7514 9.3592 37.1687 8.70364 35.5185 8.70364ZM29.2963 21.1481C29.2963 22.2482 28.8592 23.3033 28.0813 24.0813C27.3034 24.8592 26.2483 25.2962 25.1481 25.2962C24.0479 25.2962 22.9929 24.8592 22.2149 24.0813C21.437 23.3033 21 22.2482 21 21.1481C21 20.0479 21.437 18.9928 22.2149 18.2149C22.9929 17.437 24.0479 16.9999 25.1481 16.9999C26.2483 16.9999 27.3034 17.437 28.0813 18.2149C28.8592 18.9928 29.2963 20.0479 29.2963 21.1481V21.1481Z"
      fill="url(#paint0_linear_1_1779)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1_1779"
        x1="7.82095"
        y1="49.8394"
        x2="54.1832"
        y2="4.7122"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#982DEC" />
        <stop offset="0.572917" stop-color="#DC8DF8" />
        <stop offset="0.895833" stop-color="#A9C4F3" />
      </linearGradient>
    </defs>
  </SvgWrapper>
);

export const IconBackground = (props) => (
  <SvgWrapper width="80" height="88" viewBox="0 0 80 88" {...props}>
    <path
      d="M40 8.5C61.7592 8.5 79.5 26.1397 79.5 47.8955C79.4999 69.6512 61.7591 87.291 40 87.291C18.2409 87.291 0.500056 69.6512 0.5 47.8955C0.5 26.1397 18.2408 8.5 40 8.5Z"
      fill="url(#paint0_radial_icon_bg)"
    />
    <path
      d="M40 8.5C61.7592 8.5 79.5 26.1397 79.5 47.8955C79.4999 69.6512 61.7591 87.291 40 87.291C18.2409 87.291 0.500056 69.6512 0.5 47.8955C0.5 26.1397 18.2408 8.5 40 8.5Z"
      stroke="url(#paint1_radial_icon_bg)"
    />
    <path
      d="M40 8.5C61.7592 8.5 79.5 26.1397 79.5 47.8955C79.4999 69.6512 61.7591 87.291 40 87.291C18.2409 87.291 0.500056 69.6512 0.5 47.8955C0.5 26.1397 18.2408 8.5 40 8.5Z"
      stroke="url(#paint2_radial_icon_bg)"
    />
    <path
      d="M40 8.5C61.7592 8.5 79.5 26.1397 79.5 47.8955C79.4999 69.6512 61.7591 87.291 40 87.291C18.2409 87.291 0.500056 69.6512 0.5 47.8955C0.5 26.1397 18.2408 8.5 40 8.5Z"
      stroke="url(#paint3_radial_icon_bg)"
    />
    <g filter="url(#filter1_f_icon_bg)">
      <ellipse
        cx="39.7436"
        cy="29.4822"
        rx="25.3846"
        ry="16.3673"
        fill="url(#paint4_radial_icon_bg)"
        fillOpacity="0.2"
      />
    </g>
    <defs>
      <filter
        id="filter1_f_icon_bg"
        x="1.40441"
        y="0.160334"
        width="76.6783"
        height="58.6438"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="6.47727"
          result="effect1_foregroundBlur_icon_bg"
        />
      </filter>
      <radialGradient
        id="paint0_radial_icon_bg"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(80 88.6775 -88.9099 30.9913 6.69204 8)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.36" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_icon_bg"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(75.4483 52.9093 -53.048 29.228 -42.5965 16.1628)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.06" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_icon_bg"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-63.3459 21.3366 -69.4701 -24.273 103.421 61.4008)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8470FF" />
        <stop offset="1" stopColor="#865CFF" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_icon_bg"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(30.3238 32.7638 -32.8497 11.7472 40.871 -10.2359)"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_icon_bg"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(0 24.2566 -37.625 0.426854 39.7436 13.1149)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </radialGradient>
    </defs>
  </SvgWrapper>
);

export const Wallet = (props) => (
  <SvgWrapper width="50" height="50" viewBox="0 0 50 50" {...props}>
    <path
      d="M39.9332 15.6666V11.9333C39.9332 9.87435 38.2589 8.19995 36.1999 8.19995H11.9333C8.84579 8.19995 6.33325 10.7125 6.33325 13.8V36.1999C6.33325 40.3085 9.68205 41.7999 11.9333 41.7999H39.9332C41.9922 41.7999 43.6666 40.1255 43.6666 38.0666V19.4C43.6666 17.341 41.9922 15.6666 39.9332 15.6666ZM36.1999 32.4666H32.4666V25H36.1999V32.4666ZM11.9333 15.6666C11.4526 15.6451 10.9988 15.4391 10.6663 15.0913C10.3338 14.7436 10.1482 14.2811 10.1482 13.8C10.1482 13.3188 10.3338 12.8563 10.6663 12.5086C10.9988 12.1608 11.4526 11.9548 11.9333 11.9333H36.1999V15.6666H11.9333Z"
      fill="url(#paint0_linear_1_1794)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1_1794"
        x1="13.1388"
        y1="58.2499"
        x2="59.6098"
        y2="18.0428"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#982DEC" />
        <stop offset="0.572917" stop-color="#DC8DF8" />
        <stop offset="0.895833" stop-color="#A9C4F3" />
      </linearGradient>
    </defs>
  </SvgWrapper>
);

export const ArrowRight = (props) => (
  <SvgWrapper
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M12.9091 7L18 12M18 12L12.9091 17M18 12L6 12"
      stroke="#17B745"
      stroke-width="2"
      stroke-linecap="square"
    />
  </SvgWrapper>
);

export const HeroLeft = (props) => (
  <SvgWrapper
    xmlns="http://www.w3.org/2000/svg"
    width="821"
    height="1249"
    viewBox="0 0 821 1249"
    fill="none"
    {...props}
  >
    <foreignObject x="-962.268" y="-352.597" width="1902.6" height="1721.35">
      <div
        xmlns="http://www.w3.org/1999/xhtml"
        style={{
          backdropFilter: "blur(60px)",
          clipPath: "url(#bgblur_0_1_1734_clip_path)",
          height: "100%",
          width: "100%",
        }}
      ></div>
    </foreignObject>
    <g data-figma-bg-blur-radius="120">
      <path
        d="M477.208 173.319C835.098 112.483 962.561 628.081 617.549 741.01L315.445 839.894C230.887 867.571 177.641 951.108 188.252 1039.45C213.583 1250.32 -76.8671 1332.86 -166.221 1140.18L-174.958 1121.34C-210.988 1043.64 -294.576 999.691 -379.009 1014.04L-490.463 1032.99C-856.712 1095.25 -988.046 568.201 -635.439 451.227C-494.558 404.492 -408.887 261.909 -433.769 115.579C-496.029 -250.578 32.7436 -376.31 149.671 -23.7841C195.255 113.649 334.46 197.584 477.208 173.319Z"
        fill="url(#paint0_linear_1_1734)"
        fill-opacity="0.1"
      />
      <path
        d="M477.962 177.755C830.359 117.853 955.865 625.538 616.149 736.733L314.045 835.617C227.448 863.962 172.917 949.514 183.784 1039.98C208.504 1245.77 -74.9402 1326.32 -162.139 1138.29L-170.875 1119.45C-207.759 1039.91 -293.329 994.914 -379.762 1009.61L-491.217 1028.55C-851.974 1089.88 -981.36 570.725 -634.022 455.499C-491.032 408.063 -404.078 263.345 -429.332 114.824C-459.995 -65.5094 -345.346 -186.543 -208.201 -219.231C-71.0369 -251.924 87.7966 -196.037 145.4 -22.3675C191.682 117.168 333.016 202.394 477.962 177.755Z"
        stroke="url(#paint1_linear_1_1734)"
        stroke-opacity="0.1"
        stroke-width="9"
      />
    </g>
    <defs>
      <clipPath
        id="bgblur_0_1_1734_clip_path"
        transform="translate(962.268 352.597)"
      >
        <path d="M477.208 173.319C835.098 112.483 962.561 628.081 617.549 741.01L315.445 839.894C230.887 867.571 177.641 951.108 188.252 1039.45C213.583 1250.32 -76.8671 1332.86 -166.221 1140.18L-174.958 1121.34C-210.988 1043.64 -294.576 999.691 -379.009 1014.04L-490.463 1032.99C-856.712 1095.25 -988.046 568.201 -635.439 451.227C-494.558 404.492 -408.887 261.909 -433.769 115.579C-496.029 -250.578 32.7436 -376.31 149.671 -23.7841C195.255 113.649 334.46 197.584 477.208 173.319Z" />
      </clipPath>
      <linearGradient
        id="paint0_linear_1_1734"
        x1="768.759"
        y1="409.562"
        x2="-954.971"
        y2="839.336"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="0.473671" stop-color="#8EFF59" />
        <stop offset="1" stop-color="#EAFBFF" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1_1734"
        x1="800.845"
        y1="680.86"
        x2="-192.99"
        y2="1326.47"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#19AF00" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
    </defs>
  </SvgWrapper>
);

export const HeroRight = (props) => (
  <SvgWrapper
    xmlns="http://www.w3.org/2000/svg"
    width="1264"
    height="1967"
    viewBox="0 0 1264 1967"
    fill="none"
    {...props}
  >
    <foreignObject x="-119.5" y="-393.5" width="2306.5" height="2480">
      <div
        xmlns="http://www.w3.org/1999/xhtml"
        style={{
          backdropFilter: "blur(60px)",
          clipPath: "url(#bgblur_0_1_1507_clip_path)",
          height: "100%",
          width: "100%",
        }}
      ></div>
    </foreignObject>
    <path
      data-figma-bg-blur-radius="120"
      d="M5.00002 -178L5 -269L1176.75 -269C1275.19 -269 1355 -189.195 1355 -90.7499C1355 7.69489 1434.81 87.5001 1533.25 87.5001L1762.5 87.5001C1928.19 87.5 2062.5 221.815 2062.5 387.5L2062.5 1024.75L2062.5 1591C2062.5 1795.9 1896.4 1962 1691.5 1962C1486.6 1962 1320.5 1795.9 1320.5 1591L1320.5 950.5C1320.5 784.815 1186.19 650.5 1020.5 650.5L965.534 650.5C817.495 650.5 695.605 534.13 688.75 386.25C681.895 238.37 560.005 122 411.966 122L305 122C139.315 122 5.00004 -12.3142 5.00002 -178Z"
      fill="url(#paint0_linear_1_1507)"
      fill-opacity="0.04"
      stroke="url(#paint1_linear_1_1507)"
      stroke-opacity="0.6"
      stroke-width="9"
    />
    <defs>
      <clipPath
        id="bgblur_0_1_1507_clip_path"
        transform="translate(119.5 393.5)"
      >
        <path d="M5.00002 -178L5 -269L1176.75 -269C1275.19 -269 1355 -189.195 1355 -90.7499C1355 7.69489 1434.81 87.5001 1533.25 87.5001L1762.5 87.5001C1928.19 87.5 2062.5 221.815 2062.5 387.5L2062.5 1024.75L2062.5 1591C2062.5 1795.9 1896.4 1962 1691.5 1962C1486.6 1962 1320.5 1795.9 1320.5 1591L1320.5 950.5C1320.5 784.815 1186.19 650.5 1020.5 650.5L965.534 650.5C817.495 650.5 695.605 534.13 688.75 386.25C681.895 238.37 560.005 122 411.966 122L305 122C139.315 122 5.00004 -12.3142 5.00002 -178Z" />
      </clipPath>
      <linearGradient
        id="paint0_linear_1_1507"
        x1="59.0001"
        y1="-269"
        x2="1845"
        y2="1920.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EBEBEB" stop-opacity="0.35" />
        <stop stop-color="white" stop-opacity="0.693532" />
        <stop offset="0.388975" stop-color="#8DFFCF" />
        <stop offset="0.994177" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1_1507"
        x1="2527.5"
        y1="212.5"
        x2="1226.5"
        y2="-192.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.193793" stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
    </defs>
  </SvgWrapper>
);

export const Rocket = (props) => (
  <SvgWrapper
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M7.35156 14.4219C6.46094 17.0703 2.92969 17.0703 2.92969 17.0703C2.92969 17.0703 2.92969 13.539 5.57812 12.6484"
      stroke="#F8F9FF"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.3047 8.23439L10 13.5391L6.46094 10L11.7656 4.69532C13.7734 2.68751 15.7813 2.71095 16.6406 2.83595C16.7732 2.85364 16.8963 2.91448 16.9909 3.00908C17.0855 3.10368 17.1464 3.22678 17.1641 3.35939C17.2891 4.21876 17.3125 6.22657 15.3047 8.23439Z"
      stroke="#F8F9FF"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.4219 9.11723V14.1641C14.4195 14.329 14.3521 14.4862 14.2344 14.6016L11.7109 17.1329C11.6309 17.2128 11.5306 17.2695 11.4208 17.297C11.3111 17.3244 11.1959 17.3216 11.0876 17.2887C10.9794 17.2558 10.882 17.1941 10.8061 17.1103C10.7301 17.0264 10.6783 16.9235 10.6562 16.8125L10 13.5391"
      stroke="#F8F9FF"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.8829 5.57811H5.836C5.67115 5.58045 5.5139 5.64785 5.3985 5.76561L2.86725 8.28904C2.78729 8.3691 2.73055 8.46937 2.70311 8.57914C2.67567 8.68892 2.67854 8.80408 2.71142 8.91235C2.7443 9.02062 2.80596 9.11794 2.88982 9.19391C2.97367 9.26988 3.07658 9.32166 3.18756 9.34373L6.461 9.99998"
      stroke="#F8F9FF"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </SvgWrapper>
);

export const Group = (props) => (
  <SvgWrapper width="40" height="40" viewBox="0 0 40 40" fill="none" {...props}>
    <g clip-path="url(#clip0_1_1740)">
      <path
        d="M4.99999 5H35C35.442 5 35.8659 5.17559 36.1785 5.48816C36.4911 5.80072 36.6667 6.22464 36.6667 6.66667V33.3333C36.6667 33.7754 36.4911 34.1993 36.1785 34.5118C35.8659 34.8244 35.442 35 35 35H4.99999C4.55797 35 4.13404 34.8244 3.82148 34.5118C3.50892 34.1993 3.33333 33.7754 3.33333 33.3333V6.66667C3.33333 6.22464 3.50892 5.80072 3.82148 5.48816C4.13404 5.17559 4.55797 5 4.99999 5ZM20.1 19.4717L9.41333 10.3967L7.255 12.9367L20.1217 23.8617L32.7567 12.9283L30.5767 10.4067L20.1017 19.4717H20.1Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_1740">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </SvgWrapper>
);

export const Phone = (props) => (
  <SvgWrapper
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0_1_1746)">
      <path
        d="M35 27.3667V33.26C35.0002 33.682 34.8403 34.0883 34.5527 34.397C34.265 34.7057 33.8709 34.8938 33.45 34.9233C32.7217 34.9733 32.1267 35 31.6667 35C16.9383 35 5 23.0617 5 8.33333C5 7.87333 5.025 7.27833 5.07667 6.55C5.1062 6.12907 5.2943 5.73502 5.60301 5.44735C5.91171 5.15968 6.31804 4.99981 6.74 5H12.6333C12.8401 4.99979 13.0395 5.07643 13.1929 5.21503C13.3463 5.35364 13.4427 5.5443 13.4633 5.75C13.5017 6.13333 13.5367 6.43833 13.57 6.67C13.9012 8.98154 14.58 11.2297 15.5833 13.3383C15.7417 13.6717 15.6383 14.07 15.3383 14.2833L11.7417 16.8533C13.9408 21.9774 18.0242 26.0609 23.1483 28.26L25.715 24.67C25.8199 24.5233 25.973 24.4181 26.1475 24.3728C26.322 24.3274 26.5069 24.3447 26.67 24.4217C28.7784 25.4231 31.026 26.1002 33.3367 26.43C33.5683 26.4633 33.8733 26.5 34.2533 26.5367C34.4587 26.5577 34.649 26.6543 34.7873 26.8076C34.9255 26.961 35.0019 27.1602 35.0017 27.3667H35Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_1746">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </SvgWrapper>
);

export const Instagram = (props) => (
  <SvgWrapper
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0_1_1705)">
      <path
        d="M12 2C14.717 2 15.056 2.01 16.122 2.06C17.187 2.11 17.912 2.277 18.55 2.525C19.21 2.779 19.766 3.123 20.322 3.678C20.8305 4.1779 21.224 4.78259 21.475 5.45C21.722 6.087 21.89 6.813 21.94 7.878C21.987 8.944 22 9.283 22 12C22 14.717 21.99 15.056 21.94 16.122C21.89 17.187 21.722 17.912 21.475 18.55C21.2247 19.2178 20.8311 19.8226 20.322 20.322C19.822 20.8303 19.2173 21.2238 18.55 21.475C17.913 21.722 17.187 21.89 16.122 21.94C15.056 21.987 14.717 22 12 22C9.283 22 8.944 21.99 7.878 21.94C6.813 21.89 6.088 21.722 5.45 21.475C4.78233 21.2245 4.17753 20.8309 3.678 20.322C3.16941 19.8222 2.77593 19.2175 2.525 18.55C2.277 17.913 2.11 17.187 2.06 16.122C2.013 15.056 2 14.717 2 12C2 9.283 2.01 8.944 2.06 7.878C2.11 6.812 2.277 6.088 2.525 5.45C2.77524 4.78218 3.1688 4.17732 3.678 3.678C4.17767 3.16923 4.78243 2.77573 5.45 2.525C6.088 2.277 6.812 2.11 7.878 2.06C8.944 2.013 9.283 2 12 2ZM12 7C10.6739 7 9.40215 7.52678 8.46447 8.46447C7.52678 9.40215 7 10.6739 7 12C7 13.3261 7.52678 14.5979 8.46447 15.5355C9.40215 16.4732 10.6739 17 12 17C13.3261 17 14.5979 16.4732 15.5355 15.5355C16.4732 14.5979 17 13.3261 17 12C17 10.6739 16.4732 9.40215 15.5355 8.46447C14.5979 7.52678 13.3261 7 12 7ZM18.5 6.75C18.5 6.41848 18.3683 6.10054 18.1339 5.86612C17.8995 5.6317 17.5815 5.5 17.25 5.5C16.9185 5.5 16.6005 5.6317 16.3661 5.86612C16.1317 6.10054 16 6.41848 16 6.75C16 7.08152 16.1317 7.39946 16.3661 7.63388C16.6005 7.8683 16.9185 8 17.25 8C17.5815 8 17.8995 7.8683 18.1339 7.63388C18.3683 7.39946 18.5 7.08152 18.5 6.75ZM12 9C12.7956 9 13.5587 9.31607 14.1213 9.87868C14.6839 10.4413 15 11.2044 15 12C15 12.7956 14.6839 13.5587 14.1213 14.1213C13.5587 14.6839 12.7956 15 12 15C11.2044 15 10.4413 14.6839 9.87868 14.1213C9.31607 13.5587 9 12.7956 9 12C9 11.2044 9.31607 10.4413 9.87868 9.87868C10.4413 9.31607 11.2044 9 12 9Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_1705">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </SvgWrapper>
);
export const Twitter = (props) => (
  <SvgWrapper
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0_1_1708)">
      <path
        d="M22.162 5.65593C21.3986 5.99362 20.589 6.2154 19.76 6.31393C20.6337 5.79136 21.2877 4.96894 21.6 3.99993C20.78 4.48793 19.881 4.82993 18.944 5.01493C18.3146 4.34151 17.4804 3.89489 16.5709 3.74451C15.6615 3.59413 14.7279 3.74842 13.9153 4.18338C13.1026 4.61834 12.4564 5.30961 12.0771 6.14972C11.6978 6.98983 11.6067 7.93171 11.818 8.82893C10.1551 8.74558 8.52832 8.31345 7.04328 7.56059C5.55823 6.80773 4.24812 5.75097 3.19799 4.45893C2.82628 5.09738 2.63095 5.82315 2.63199 6.56193C2.63199 8.01193 3.36999 9.29293 4.49199 10.0429C3.828 10.022 3.17862 9.84271 2.59799 9.51993V9.57193C2.59819 10.5376 2.93236 11.4735 3.54384 12.221C4.15532 12.9684 5.00647 13.4814 5.95299 13.6729C5.33661 13.84 4.6903 13.8646 4.06299 13.7449C4.32986 14.5762 4.85 15.3031 5.55058 15.824C6.25117 16.3449 7.09712 16.6337 7.96999 16.6499C7.10247 17.3313 6.10917 17.8349 5.04687 18.1321C3.98458 18.4293 2.87412 18.5142 1.77899 18.3819C3.69069 19.6114 5.91609 20.264 8.18899 20.2619C15.882 20.2619 20.089 13.8889 20.089 8.36193C20.089 8.18193 20.084 7.99993 20.076 7.82193C20.8949 7.23009 21.6016 6.49695 22.163 5.65693L22.162 5.65593Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_1708">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </SvgWrapper>
);

export const Facebook = (props) => (
  <SvgWrapper
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0_1_1702)">
      <path
        d="M14 13.5H16.5L17.5 9.5H14V7.5C14 6.47 14 5.5 16 5.5H17.5V2.14C17.174 2.097 15.943 2 14.643 2C11.928 2 10 3.657 10 6.7V9.5H7V13.5H10V22H14V13.5Z"
        fill="#1B7DBE"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_1702">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </SvgWrapper>
);

export const Youtube = (props) => (
  <SvgWrapper
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0_1_1711)">
      <path
        d="M21.543 6.498C22 8.28 22 12 22 12C22 12 22 15.72 21.543 17.502C21.289 18.487 20.546 19.262 19.605 19.524C17.896 20 12 20 12 20C12 20 6.107 20 4.395 19.524C3.45 19.258 2.708 18.484 2.457 17.502C2 15.72 2 12 2 12C2 12 2 8.28 2.457 6.498C2.711 5.513 3.454 4.738 4.395 4.476C6.107 4 12 4 12 4C12 4 17.896 4 19.605 4.476C20.55 4.742 21.292 5.516 21.543 6.498ZM10 15.5L16 12L10 8.5V15.5Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_1711">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </SvgWrapper>
);

export const Send = (props) => (
  <SvgWrapper
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M3 12.9996H9V10.9996H3V1.84562C3.00001 1.75873 3.02267 1.67335 3.06573 1.59789C3.1088 1.52242 3.17078 1.45949 3.24558 1.41527C3.32037 1.37106 3.4054 1.34711 3.49227 1.34576C3.57915 1.34442 3.66487 1.36574 3.741 1.40762L22.203 11.5616C22.2814 11.6048 22.3468 11.6682 22.3923 11.7452C22.4378 11.8223 22.4618 11.9101 22.4618 11.9996C22.4618 12.0891 22.4378 12.177 22.3923 12.254C22.3468 12.331 22.2814 12.3945 22.203 12.4376L3.741 22.5916C3.66487 22.6335 3.57915 22.6548 3.49227 22.6535C3.4054 22.6521 3.32037 22.6282 3.24558 22.584C3.17078 22.5397 3.1088 22.4768 3.06573 22.4013C3.02267 22.3259 3.00001 22.2405 3 22.1536V12.9996Z"
      fill="white"
    />
  </SvgWrapper>
);
export const Copyright = (props) => (
  <SvgWrapper
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M10 0C15.52 0 20 4.48 20 10C20 15.52 15.52 20 10 20C4.48 20 0 15.52 0 10C0 4.48 4.48 0 10 0ZM10 2C5.58 2 2 5.58 2 10C2 14.42 5.58 18 10 18C14.42 18 18 14.42 18 10C18 5.58 14.42 2 10 2ZM10 5C11.82 5 13.413 5.973 14.288 7.428L12.574 8.457C12.3043 8.00724 11.9213 7.63605 11.4634 7.38045C11.0055 7.12484 10.4885 6.99374 9.96412 7.00023C9.43971 7.00672 8.92617 7.15056 8.4747 7.41742C8.02323 7.68428 7.6496 8.06483 7.39107 8.52112C7.13254 8.97742 6.99815 9.49351 7.00128 10.0179C7.00442 10.5424 7.14498 11.0568 7.40895 11.51C7.67292 11.9632 8.05107 12.3392 8.5057 12.6007C8.96033 12.8621 9.47556 12.9998 10 13C10.5181 13.0003 11.0275 12.8664 11.4785 12.6112C11.9294 12.356 12.3065 11.9883 12.573 11.544L14.288 12.572C13.726 13.5106 12.8716 14.239 11.8559 14.6453C10.8402 15.0517 9.71922 15.1137 8.6649 14.8217C7.61058 14.5298 6.68114 13.9 6.01914 13.029C5.35713 12.1581 4.99912 11.094 5 10C5 7.24 7.24 5 10 5Z"
      fill="white"
    />
  </SvgWrapper>
);

export const MobileHeroLeft = (props) => (
  <SvgWrapper
    width="94"
    height="807"
    viewBox="0 0 94 807"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <foreignObject x="-1721.98" y="-1009.77" width="1935.86" height="1935.93">
      <div
        xmlns="http://www.w3.org/1999/xhtml"
        style={{
          backdropFilter: "blur(60px)",
          clipPath: "url(#bgblur_0_1_2129_clip_path)",
          height: "100%",
          width: "100%",
        }}
      ></div>
    </foreignObject>
    <g data-figma-bg-blur-radius="120">
      <path
        d="M-231.478 -428.088C138.803 -458.187 223.773 78.2921 -137.686 164.089C-282.104 198.369 -379.876 332.942 -367.843 480.884C-337.733 851.073 -874.079 936.022 -959.837 574.646C-994.109 430.227 -1128.68 332.453 -1276.62 344.479C-1646.9 374.578 -1731.88 -161.901 -1370.42 -247.698C-1226 -281.978 -1128.23 -416.551 -1140.26 -564.493C-1170.37 -934.682 -634.023 -1019.63 -548.265 -658.255C-513.993 -513.836 -379.421 -416.062 -231.478 -428.088Z"
        fill="url(#paint0_linear_1_2129)"
        fill-opacity="0.1"
      />
      <path
        d="M-231.114 -423.602C133.625 -453.251 217.323 75.1977 -138.726 159.71C-285.306 194.503 -384.542 331.092 -372.329 481.249C-342.669 845.895 -870.984 929.572 -955.458 573.607C-990.244 427.025 -1126.83 327.788 -1276.99 339.993C-1641.73 369.642 -1725.43 -158.807 -1369.38 -243.319C-1222.8 -278.112 -1123.56 -414.701 -1135.77 -564.858C-1165.43 -929.504 -637.118 -1013.18 -552.644 -657.216C-517.858 -510.634 -381.271 -411.397 -231.114 -423.602Z"
        stroke="url(#paint1_linear_1_2129)"
        stroke-opacity="0.1"
        stroke-width="9"
      />
    </g>
    <defs>
      <clipPath
        id="bgblur_0_1_2129_clip_path"
        transform="translate(1721.98 1009.77)"
      >
        <path d="M-231.478 -428.088C138.803 -458.187 223.773 78.2921 -137.686 164.089C-282.104 198.369 -379.876 332.942 -367.843 480.884C-337.733 851.073 -874.079 936.022 -959.837 574.646C-994.109 430.227 -1128.68 332.453 -1276.62 344.479C-1646.9 374.578 -1731.88 -161.901 -1370.42 -247.698C-1226 -281.978 -1128.23 -416.551 -1140.26 -564.493C-1170.37 -934.682 -634.023 -1019.63 -548.265 -658.255C-513.993 -513.836 -379.421 -416.062 -231.478 -428.088Z" />
      </clipPath>
      <linearGradient
        id="paint0_linear_1_2129"
        x1="32.0708"
        y1="-166.821"
        x2="-1722.56"
        y2="111.085"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="0.473671" stop-color="#8EFF59" />
        <stop offset="1" stop-color="#EAFBFF" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1_2129"
        x1="40.3887"
        y1="106.241"
        x2="-1005.93"
        y2="662.773"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#19AF00" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
    </defs>
  </SvgWrapper>
);

export const MobileHeroRight = (props) => (
  <SvgWrapper
    xmlns="http://www.w3.org/2000/svg"
    width="375"
    height="1129"
    viewBox="0 0 375 1129"
    fill="none"
    {...props}
  >
    <foreignObject x="-311.5" y="-352.5" width="1062" height="1601">
      <div
        xmlns="http://www.w3.org/1999/xhtml"
        style={{
          backdropFilter: "blur(60px)",
          clipPath: "url(#bgblur_0_1_2125_clip_path)",
          height: "100%",
          width: "100%",
        }}
      ></div>
    </foreignObject>
    <path
      opacity="0.28"
      data-figma-bg-blur-radius="120"
      d="M-187 -125.724L-187 -228L238.418 -228C298.076 -228 346.438 -179.638 346.438 -119.979C346.439 -60.3214 394.801 -11.9588 454.459 -11.9589L486.219 -11.9589C563.418 -11.9589 626 50.6231 626 127.822L626 556.021L626 977.403C626 1058.37 560.366 1124 479.403 1124C398.44 1124 332.806 1058.37 332.806 977.403L332.806 453.467C332.806 384.849 277.18 329.223 208.562 329.223C141.406 329.223 86.4042 275.858 84.3752 208.733L82.2841 139.552C80.0847 66.7921 20.4662 8.94843 -52.3272 8.94845C-126.705 8.94846 -187 -51.3467 -187 -125.724Z"
      fill="url(#paint0_linear_1_2125)"
      fill-opacity="0.04"
      stroke="url(#paint1_linear_1_2125)"
      stroke-opacity="0.6"
      stroke-width="9"
    />
    <defs>
      <clipPath
        id="bgblur_0_1_2125_clip_path"
        transform="translate(311.5 352.5)"
      >
        <path d="M-187 -125.724L-187 -228L238.418 -228C298.076 -228 346.438 -179.638 346.438 -119.979C346.439 -60.3214 394.801 -11.9588 454.459 -11.9589L486.219 -11.9589C563.418 -11.9589 626 50.6231 626 127.822L626 556.021L626 977.403C626 1058.37 560.366 1124 479.403 1124C398.44 1124 332.806 1058.37 332.806 977.403L332.806 453.467C332.806 384.849 277.18 329.223 208.562 329.223C141.406 329.223 86.4042 275.858 84.3752 208.733L82.2841 139.552C80.0847 66.7921 20.4662 8.94843 -52.3272 8.94845C-126.705 8.94846 -187 -51.3467 -187 -125.724Z" />
      </clipPath>
      <linearGradient
        id="paint0_linear_1_2125"
        x1="-165.662"
        y1="-228"
        x2="912.056"
        y2="633.474"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EBEBEB" stop-opacity="0.35" />
        <stop stop-color="white" stop-opacity="0.693532" />
        <stop offset="0.388975" stop-color="#8DFFCF" />
        <stop offset="0.994177" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1_2125"
        x1="809.74"
        y1="63.7919"
        x2="268.159"
        y2="-46.1376"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.193793" stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
    </defs>
  </SvgWrapper>
);

const VectorImages = {
  ArrowsExchange,
  Cash,
  Wallet,
  ArrowRight,
  Rocket,
  Group,
  Phone,
  Instagram,
  Twitter,
  Facebook,
  Youtube,
  Send,
  Copyright,
};

export default VectorImages;
